<template>
  <div class="tnc d-flex flex-column align-items-center">
    <h2 align="center">商戶中心使用條款與細則</h2>
    <br>
    <TNCText class="tnc-container"></TNCText>
  </div>
</template>

<script>
import TNCText from '@/views/static/content/TNCText.vue';

export default {
  components: {
    TNCText,
  },
};
</script>

<style lang="scss" scoped>
.tnc {
  padding: 1rem;

  &-container {
    max-width: 50rem;
  }
}
</style>
